import BankService from '@/services/BankService';

export default {
  async getBanks ({ commit, state }) {
    const banks = await BankService.getBanks();
    commit('SET_BANKS', banks);
  },
};
